import { colors, getRecipeColor, IconSize } from '@ui-components/neo.tax';
import { ReactComponent as AlarmBellRing } from '@ui-components/neo.tax/dist/icons/alarm-bell-ring.svg';
import { ReactComponent as Briefcase } from '@ui-components/neo.tax/dist/icons/briefcase.svg';
import { ReactComponent as CheckCircle } from '@ui-components/neo.tax/dist/icons/check-circle-1.svg';
import { ReactComponent as Close } from '@ui-components/neo.tax/dist/icons/close.svg';
import { ReactComponent as LabTube } from '@ui-components/neo.tax/dist/icons/lab-tube-bottle.svg';
import { ReactComponent as LaptopFlash } from '@ui-components/neo.tax/dist/icons/laptop-flash.svg';
import { ReactComponent as Parts } from '@ui-components/neo.tax/dist/icons/model-parts-2.svg';

import { RdProject } from '@neo.tax/rd/hooks';
import {
  hasBusinessComponent,
  hasProcessOfExperimentation,
  hasPurpose,
  hasTechnicalChallenges,
} from '@neo.tax/rd/utils';
import { HIGHLIGHT_VARIANT } from '@neo.tax/shared';

export const disallowanceItemProps = (
  project: RdProject,
): { iconNode: React.ReactElement; iconBgColor?: string; iconNodeSize?: IconSize } => {
  // Maps to "none of the above" option
  if (project.disallowances && project.disallowances.length === 0) {
    return {
      iconNode: <CheckCircle color={colors.white} />,
      iconBgColor: getRecipeColor(HIGHLIGHT_VARIANT, 'whiteBg').text,
    };
  }

  // Maps to one or more disallowances selected
  if (project.disallowances && project.disallowances.length > 0) {
    return {
      iconNode: <Close color={colors.white} />,
      iconBgColor: colors.rsbry[600],
      iconNodeSize: 4,
    };
  }

  // Maps to nothing selected
  return {
    iconNode: <AlarmBellRing />,
  };
};

export const purposeProps = (project: RdProject): { iconNode: React.ReactElement; iconBgColor?: string } => {
  if (hasPurpose(project)) {
    return {
      iconNode: <CheckCircle color={colors.white} />,
      iconBgColor: getRecipeColor(HIGHLIGHT_VARIANT, 'whiteBg').text,
    };
  }
  return {
    iconNode: <Briefcase />,
  };
};

export const businessComponentProps = (project: RdProject): { iconNode: React.ReactElement; iconBgColor?: string } => {
  if (hasBusinessComponent(project)) {
    return {
      iconNode: <CheckCircle color={colors.white} />,
      iconBgColor: getRecipeColor(HIGHLIGHT_VARIANT, 'whiteBg').text,
    };
  }
  return {
    iconNode: <Parts />,
  };
};

export const technicalChallengesProps = (
  project: RdProject,
): { iconNode: React.ReactElement; iconBgColor?: string } => {
  if (hasTechnicalChallenges(project)) {
    return {
      iconNode: <CheckCircle color={colors.white} />,
      iconBgColor: getRecipeColor(HIGHLIGHT_VARIANT, 'whiteBg').text,
    };
  }
  return {
    iconNode: <LaptopFlash />,
  };
};

export const processOfExperimentationProps = (
  project: RdProject,
): { iconNode: React.ReactElement; iconBgColor?: string } => {
  if (hasProcessOfExperimentation(project)) {
    return {
      iconNode: <CheckCircle color={colors.white} />,
      iconBgColor: getRecipeColor(HIGHLIGHT_VARIANT, 'whiteBg').text,
    };
  }
  return {
    iconNode: <LabTube />,
  };
};
